// @flow
import { takeLatest, select } from 'redux-saga/effects';
import type { Saga, Pattern } from 'redux-saga';
import dataLayer from '@rover/globals/dataLayer';

function* trackAction(getData, action): Saga<void> {
  const data = yield select(state => getData(state, action));

  if (!data) {
    return;
  }

  if (Array.isArray(data)) {
    data.forEach(i => {
      console.debug('dataLayer', i);
      dataLayer.push(i);
    });
  } else {
    console.debug('dataLayer', data);
    dataLayer.push(data);
  }
}

const createAnalyticsSaga = (actionTypes: Pattern, getData: Function): (() => Saga<void>) =>
  function* analyticsSaga() {
    yield takeLatest(actionTypes, trackAction, getData);
  };

export default createAnalyticsSaga;



// WEBPACK FOOTER //
// ../react-lib/src/redux/createAnalyticsSaga.js